import FormController from "../../controllers/offer/form_controller";
export default FormController;